// Imports: local files.
import {
  GET_FORMAL_EDUCATION_START,
  GET_FORMAL_EDUCATION_SUCCESS,
  GET_FORMAL_EDUCATION_FAILED,
  GET_FORMAL_EDUCATION_RESET,
  GET_HOME_PAGE_FORMAL_EDUCATION_START,
  GET_HOME_PAGE_FORMAL_EDUCATION_SUCCESS,
  GET_HOME_PAGE_FORMAL_EDUCATION_FAILED,
  GET_HOME_PAGE_FORMAL_EDUCATION_RESET,
  CREATE_OR_UPDATE_FORMAL_EDUCATION_START,
  CREATE_OR_UPDATE_FORMAL_EDUCATION_SUCCESS,
  CREATE_OR_UPDATE_FORMAL_EDUCATION_FAILED,
  CREATE_OR_UPDATE_FORMAL_EDUCATION_RESET,
} from '../actions/formalEducation.actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getFormalEducation: initialLoadingState,
  getHomePage: initialLoadingState,
  createOrUpdate: initialLoadingState,
};

const formalEducationReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get Complete Formal Education Content
     * =======================================================================
     */
    case GET_FORMAL_EDUCATION_START:
      return { ...state, getFormalEducation: { ...action.payload } };
    case GET_FORMAL_EDUCATION_SUCCESS:
      return { ...state, getFormalEducation: { ...action.payload } };
    case GET_FORMAL_EDUCATION_FAILED:
      return { ...state, getFormalEducation: { ...action.payload } };
    case GET_FORMAL_EDUCATION_RESET:
      return { ...state, getFormalEducation: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get Home Page Formal Education Content
     * =======================================================================
     */
    case GET_HOME_PAGE_FORMAL_EDUCATION_START:
      return { ...state, getHomePage: { ...action.payload } };
    case GET_HOME_PAGE_FORMAL_EDUCATION_SUCCESS:
      return { ...state, getHomePage: { ...action.payload } };
    case GET_HOME_PAGE_FORMAL_EDUCATION_FAILED:
      return { ...state, getHomePage: { ...action.payload } };
    case GET_HOME_PAGE_FORMAL_EDUCATION_RESET:
      return { ...state, getHomePage: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create or Update Formal Education Content
     * =======================================================================
     */
    case CREATE_OR_UPDATE_FORMAL_EDUCATION_START:
      return { ...state, createOrUpdate: { ...action.payload } };
    case CREATE_OR_UPDATE_FORMAL_EDUCATION_SUCCESS:
      return { ...state, createOrUpdate: { ...action.payload } };
    case CREATE_OR_UPDATE_FORMAL_EDUCATION_FAILED:
      return { ...state, createOrUpdate: { ...action.payload } };
    case CREATE_OR_UPDATE_FORMAL_EDUCATION_RESET:
      return { ...state, createOrUpdate: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default formalEducationReducer;
